<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Edit Schedule Info Form"
      id="owner_view_schedule_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="schedules_form_ref"
      id="schedules_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <v-row
        no-gutterss
        class="pa-0 mb-0 align-center"
        v-for="(day, index) in days"
        :key="index"
      >
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <div class="d-flex justify-space-between text-left">
            <b>{{ days_capitalised[index] + " Openning Time: " }}</b>
            <span :class="form[day + '_openning_time_display'] == 'closed'? 'red--text' : 'primary--text'"
              ><b>{{ form[day + "_openning_time_display"] }}</b>
              <small v-if="form[day + '_openning_time_display'] != 'closed'">(12hr)</small></span
            >
          </div>
          <TimeField
            :label="'in 24hr clock'"
            v-model="form[day + '_openning_time_display']"
            :validation_rules="form_validations[day + '_openning_time_display']"
            :disabled="is_loading"
            value_format="ampm"
          ></TimeField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <div class="d-flex justify-space-between text-left">
            <b>{{ days_capitalised[index] + " Closing Time: " }}</b>
            <span :class="form[day + '_closing_time_display'] == 'closed'? 'red--text' : 'primary--text'"
              ><b>{{ form[day + "_closing_time_display"] }}</b>
              <small v-if="form[day + '_closing_time_display'] != 'closed'">(12hr)</small></span
            >
          </div>
          <TimeField
            :label="'in 24hr clock'"
            v-model="form[day + '_closing_time_display']"
            :validation_rules="form_validations[day + '_closing_time_display']"
            :disabled="is_loading"
            value_format="ampm"
          ></TimeField>
        </v-col>
        <v-col cols="2">
          <v-btn
            class="mr-4"
            :disabled="is_loading"
            color="primary"
            @click="on_set_closed(day)"
          >
            set closed
          </v-btn>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TimeField from "../../../components/TimeField";
export default {
  name: "OwnerBusinessesManageSchedule",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    TimeField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: {
        monday_openning_time_display: "",
        monday_openning_time_value: 0,
        monday_closing_time_display: "",
        monday_closing_time_value: 0,
        tuesday_openning_time_display: "",
        tuesday_openning_time_value: 0,
        tuesday_closing_time_display: "",
        tuesday_closing_time_value: 0,
        wednesday_openning_time_display: "",
        wednesday_openning_time_value: 0,
        wednesday_closing_time_display: "",
        wednesday_closing_time_value: 0,
        thursday_openning_time_display: "",
        thursday_openning_time_value: 0,
        thursday_closing_time_display: "",
        thursday_closing_time_value: 0,
        friday_openning_time_display: "",
        friday_openning_time_value: 0,
        friday_closing_time_display: "",
        friday_closing_time_value: 0,
        saturday_openning_time_display: "",
        saturday_openning_time_value: 0,
        saturday_closing_time_display: "",
        saturday_closing_time_value: 0,
        sunday_openning_time_display: "",
        sunday_openning_time_value: 0,
        sunday_closing_time_display: "",
        sunday_closing_time_value: "",
      },
      form_validations: {
        monday_openning_time_display: [],
        monday_openning_time_value: [],
        monday_closing_time_display: [],
        monday_closing_time_value: [],
        tuesday_openning_time_display: [],
        tuesday_openning_time_value: [],
        tuesday_closing_time_display: [],
        tuesday_closing_time_value: [],
        wednesday_openning_time_display: [],
        wednesday_openning_time_value: [],
        wednesday_closing_time_display: [],
        wednesday_closing_time_value: [],
        thursday_openning_time_display: [],
        thursday_openning_time_value: [],
        thursday_closing_time_display: [],
        thursday_closing_time_value: [],
        friday_openning_time_display: [],
        friday_openning_time_value: [],
        friday_closing_time_display: [],
        friday_closing_time_value: [],
        saturday_openning_time_display: [],
        saturday_openning_time_value: [],
        saturday_closing_time_display: [],
        saturday_closing_time_value: [],
        sunday_openning_time_display: [],
        sunday_openning_time_value: [],
        sunday_closing_time_display: [],
        sunday_closing_time_value: []
      },
      days: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
      days_capitalised: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    };
  },
  methods: {
    on_auto_fill() {
      for (var index = 0; index < this.days.length; index++) {
        var day = this.days[index];

        this.form[day + "_openning_time_display"] = (day == "sunday") ? "closed" : "08:00 AM";
        this.form[day + "_closing_time_display"] = (day == "sunday") ? "closed" : "05:00 PM";

      }
      this.errors = [];
      this.message = "";
    },
    init_form() {
      for (var index = 0; index < this.days.length; index++) {
        var day = this.days[index];
        var ov = this.business[day + "_openning_time_display"];
        this.form[day + "_openning_time_display"] =
          ov.length > 0 ? ov : "00:00 AM";
        this.form[day + "_openning_time_value"] = parseFloat(
          this.business[day + "_openning_time_value"]
        );
        var cv = this.business[day + "_closing_time_display"];
        this.form[day + "_closing_time_display"] =
          cv.length > 0 ? cv : "0:00 PM";
        this.form[day + "_closing_time_value"] = parseFloat(
          this.business[day + "_closing_time_value"]
        );
      }
      this.errors = [];
      this.message = "";
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.locations_form_ref.show_error_dialog();
        }
      );
    },
    on_set_closed(day){
      this.form[day + "_openning_time_display"] = "closed";
      this.form[day + "_closing_time_display"] = "closed";
    },
    submit() {
      //validate the entries
      // if either is closed both should be closed
      var val_errors = [];
      for (var index = 0; index < this.days.length; index++) {
        var day = this.days[index];
        var open_time = this.form[day + "_openning_time_display"];
        var close_time = this.form[day + "_closing_time_display"];
        if(open_time == "closed" && close_time != "closed"){
          val_errors.push(day + ": If openning time is closed, also closing time should be closed");
        }else if(close_time == "closed" && open_time != "closed"){
          val_errors.push(day + ": If closing time is closed, also openning time should be closed");
        }
        var open_time_val = parseFloat(open_time.replace("AM","").replace("PM","").replace("closed","0.0").trim().replace(":",".").trim());
        if(open_time.indexOf("PM") > -1){
          open_time_val = open_time_val + 12;
        }
        var close_time_val = parseFloat(close_time.replace("AM","").replace("PM","").replace("closed","0.0").trim().replace(":",".").trim());
        if(close_time.indexOf("PM") > -1){
          close_time_val = close_time_val + 12;
        }
        if(open_time_val  > close_time_val){
          val_errors.push(day + ": Openning time cannot be greater than closing time ");
        }
        this.form[day + "_openning_time_value"] = open_time_val; 
        this.form[day + "_closing_time_value"] = close_time_val; 
      }
      if(val_errors.length > 0){
        this.errors = val_errors;
        this.$refs.schedules_form_ref.show_error_dialog();
        return false;
      }
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.update_weekly_schedule({
        id: this.business_id,
        ... this.form
      },(res) => {
        this.$emit("on-hide-loader");
        this.message =
          "<b>Operation was successfull</b> <br/> Your business weekly schedule information has been updated successfully";
        this.$refs.schedules_form_ref.show_message_dialog();
      }, (errors) => {
        this.errors = errors;
        this.$refs.schedules_form_ref.show_error_dialog();
        this.$emit("on-hide-loader");
      });
      
    },
    on_hide_message() {
      this.load_business(this.business_id);
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Manage Schedule Info",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Schedules",
          disabled: true,
          href:
            "/owner/businesses/list/view/" +
            this.business_id +
            "/schedule/manage",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_schedule_edit_form", options);
  },
};
//efris.ura.go.ug
//download api docs
</script>